module.exports = __webpack_public_path__ + "img/logo.fe04ce5b.svg";